import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { SvgVddMapping } from '../../../projects/client';
import { AppState } from '../app.state';
import { VddDetailsListState } from '../vdd-details-list';

import { HydraulicSchematicState } from './hydraulic-schematic.state';

export namespace HydraulicSchematicSelectors {
  const HydraulicSchematic = (state: AppState): HydraulicSchematicState => state.hydraulicSchematic;
  const VddDetailsList = (state: AppState): VddDetailsListState => state.vddDetailsList;

  export const isLoading: MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > = createSelector(HydraulicSchematic, (state: HydraulicSchematicState) => state.loading);

  export const getHydraulicSchematic: MemoizedSelector<
    AppState,
    any,
    DefaultProjectorFn<any>
  > = createSelector(
    HydraulicSchematic,
    (state: HydraulicSchematicState) => state.hydraulicSchematicSvgModel
  );

  export const isHydraulicSchematicError: MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<any>
  > = createSelector(HydraulicSchematic, (state: HydraulicSchematicState) => !!state.error);

  export const getHydraulicSchematicVddsWithMapping: MemoizedSelector<
    AppState,
    SvgVddMapping[],
    DefaultProjectorFn<SvgVddMapping[]>
  > = createSelector(HydraulicSchematic, (state: HydraulicSchematicState) =>
    state?.hydraulicSchematicMapping?.filter((mapping) =>
      state?.hydraulicSchematicSvgModel?.svg?.g
        ?.map((node) => node.text?.['#text'])
        .filter((text) => !!text)
        .includes(mapping.id)
    )
  );

  export const isAnyFromHydraulicSchematicVddLoading: MemoizedSelector<
    AppState,
    boolean,
    DefaultProjectorFn<boolean>
  > = createSelector(
    getHydraulicSchematicVddsWithMapping,
    VddDetailsList,
    (hydraulicSchematicVddsWithMapping, vddDetailsListState) => {
      if (hydraulicSchematicVddsWithMapping?.length) {
        return (
          vddDetailsListState.vddDetailsList
            .filter((vdd) =>
              hydraulicSchematicVddsWithMapping
                .map((vddMapping) => vddMapping.feature)
                .includes(vdd.vddName)
            )
            .findIndex((vdd) => vdd?.structureLoading || vdd?.singleReadLoading) !== -1
        );
      } else {
        return false;
      }
    }
  );
}
